import { clone } from '@jkhy/frontend-utils/functions';
import { AccountProductConfigurationModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';

const nullAccountProductConfiguration: AccountProductConfigurationModelDto = {
    id: 0,
    accountId: 0,
    number: '',
    type: '',
    isCompanyAccount: false,
    isEnabled: false,
};

export class AccountProductConfiguration extends DomainEntity<AccountProductConfigurationModelDto> {
    constructor(dto = clone(nullAccountProductConfiguration)) {
        super(dto);
    }

    public createDefault(): this {
        return new AccountProductConfiguration(clone(nullAccountProductConfiguration)) as this;
    }

    public get accountId() {
        return this.dto.accountId;
    }

    public get accountName() {
        return this.dto.companyName;
    }

    public get accountNumber() {
        return this.dto.number;
    }

    public get accountType() {
        return this.dto.type;
    }

    public get cifNumber() {
        return this.dto.cifNumber;
    }

    public get id() {
        return this.dto.accountId;
    }

    public get isEnabled() {
        return this.dto.isEnabled;
    }
}
